module.exports = __webpack_public_path__ + "static/logo.29473128.svg";